import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// import './pages/admin.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'; //with persist

const root = ReactDOM.createRoot(document.getElementById('root'));
let persistor = persistStore(store); //with persis


root.render(
  <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
     </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
